import moment from 'moment';

export const conditionStatuses = new Set([0, 1, 2, 3, 4, 5, 12, 13, 14, 15, 16, 28, 33, 37, 39]);
export const endDateStatuses = new Set([0, 1, 2, 3, 4, 5, 12, 13, 14, 15, 16, 28, 33, 35]);
const date = value => value && moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '';
export const earliestDate = (...values) => values.filter(Boolean).sort()[0] || '';

export function claimCalendarPeriod(policy, today = moment().format('YYYY-MM-DD'), staff) {
  // Prefer actual inception when supplied; start_date may include an API waiting period.
  const staffStart = date(staff?.inception_date) || date(staff?.inception) || date(staff?.start_date);
  const start = [date(policy?.policy_inception), staffStart].filter(Boolean).sort().pop() || '';
  return { start, end: today };
}

export function lastAbsenceDateError({ absenceStart, absenceEnd, selectedStaff } = {}, policy) {
  const end = date(absenceEnd);
  if (!end) return '';
  const first = date(absenceStart);
  const inception = policy !== undefined
    ? date(policy?.policy_inception)
    : date(selectedStaff?.start_date || selectedStaff?.inception);
  const minimum = [first, inception].filter(Boolean).sort().pop();
  if (minimum && end < minimum) {
    const reason = minimum === first ? 'the first day of absence' : policy !== undefined ? 'policy inception' : 'the staff cover start date';
    return `The last day of absence cannot be before ${reason} (${moment(minimum).format('D MMM YYYY')}).`;
  }
  return '';
}

export function validateClaim(data = {}, policy, today = moment().format('YYYY-MM-DD')) {
  const errors = {};
  const { selectedStaff, selectedCondition, absenceStart, absenceEnd } = data;
  const period = claimCalendarPeriod(policy, today, selectedStaff);
  if (!selectedStaff?.staff_id) errors.staff = 'Select a staff member.';
  if (!selectedCondition?.condition_id) errors.condition = 'Select a condition.';
  if (!absenceStart || !date(absenceStart)) errors.startDate = 'Enter the first full day of absence.';
  else if (period.start && absenceStart < period.start) errors.startDate = `The first day of absence cannot be before ${moment(period.start).format('D MMM YYYY')}.`;
  else if (absenceStart > today) errors.startDate = 'The first day of absence cannot be in the future.';
  if (absenceEnd) {
    if (!date(absenceEnd)) errors.endDate = 'Enter a valid last day of absence.';
    else if (lastAbsenceDateError(data, policy || {})) errors.endDate = lastAbsenceDateError(data, policy || {});
    else if (absenceEnd > today) errors.endDate = 'The last day of absence cannot be in the future.';
  }
  return errors;
}
